if(document.body.classList.contains('template-index')) {

    // typewriter effect
    var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };
    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];
        if (this.isDeleting) {
            this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
            this.txt = fullTxt.substring(0, this.txt.length + 1);
        }
        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';
        var that = this;
        var delta = 200 - Math.random() * 100;
        if (this.isDeleting) { delta /= 2; }
        if (!this.isDeleting && this.txt === fullTxt) {
            delta = this.period;
            this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
            this.isDeleting = false;
            this.loopNum++;
            delta = 500;
        }
        setTimeout(function() {
            that.tick();
        }, delta);
    };
    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
                new TxtType(elements[i], JSON.parse(toRotate), period);
            }
        }
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
        document.body.appendChild(css);
    };

    // Product section
    /*setInterval(function(){
        var prc = document.querySelector(".featpdct .product-price .price .money");
        var qty = document.querySelector('.featpdct input.product-quantity-input');
        if(typeof(qty) != 'undefined' && qty != null) {
            var qt = qty.value;
            var prctxt = prc.innerHTML;
            var prcnum = prctxt.replace(",",".").replace("€","");
            var pr = parseFloat(prcnum) * parseFloat(qt);
            var totxt = pr.toFixed(2).replace(".",",") + "€";
            var atc = document.querySelector(".add-to-cart input");
            var atct = document.getElementById('ctaholder').textContent;
            atc.value = atct + ' ' + totxt;
        }
    }, 1000);*/
    $('#trustslider').slick({
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false
    });

    // Price section
    function addToCartOk() {
        console.log("added to cart");
        window.location.href = "/cart";
    }
    $(".order-btn").click(function(){
        var variant = $(this).attr('data-variant');
        $(".home-order-now form select.product-select").val(variant).trigger('change');
        /*$.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('.home-order-now form').serialize(),
            success: addToCartOk
        });*/
      	var pdv;
        var pnt = window.location.pathname;
        if(pnt.indexOf('/en-us') !== -1) {
          //console.log("transcy test");
          var pdv = 'https://fazup.eu/en-us/products/patch-fazup?variant=' + variant;
        } else {
        	if(variant == '37209312559271') {
            var pdv = 'https://fazup.eu/products/patch-fazup?variant=37209312559271';
          } else {
            var pdv = 'https://fazup.eu/products/patch-fazup?variant=' + variant;
          }
        }
        window.location.href = pdv;
    });
    /*$("#pickone").click(function(){
        var variant = $(this).attr('data-variant');
        $(".home-order-now form select.product-select").val(variant).trigger('change');
        $(".home-order-now form > div.product-options > div.inline-field-wrapper.js-required > div > label > span").empty().append('1 Patch + 1 offert');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('.home-order-now form').serialize(),
            success: addToCartOk
        });
    });
    $("#picktwo").click(function(){
        $(".home-order-now form select.product-select").val("35415967858854").trigger('change');
        $(".home-order-now form > div.product-options > div.inline-field-wrapper.js-required > div > label > span").empty().append('2 Patchs + 1 offert');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('#product-form-160407320889a61469').serialize(),
            success: addToCartOk
        });
    });
    $("#pickthree").click(function(){
        $(".home-order-now form select.product-select").val("35415967891622").trigger('change');
        $(".home-order-now form > div.product-options > div.inline-field-wrapper.js-required > div > label > span").empty().append('3 Patchs + 1 offert');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('#product-form-160407320889a61469').serialize(),
            success: addToCartOk
        });
    });
    $("#pickfour").click(function(){
        $(".home-order-now form select.product-select").val("35415967924390").trigger('change');
        $(".home-order-now form > div.product-options > div.inline-field-wrapper.js-required > div > label > span").empty().append('4 Patchs + 1 offert');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('#product-form-160407320889a61469').serialize(),
            success: addToCartOk
        });
    });*/
    $("#explainervideo").click(function(){
        $("#explainervideo").hide();
        $("#explainvid").show();
    });
    var num = document.querySelector('.featpdct input[name="quantity"]');
    if(typeof(num) != 'undefined' && num != null) {
        num.type = 'number';
    }
    $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.product-quantity-container input[type="number"]');
    var spinner = $('.product-quantity-container'),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');
    btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
            var newVal = oldValue;
        } else {
            var newVal = oldValue + 1;
        }
        spinner.find("input[type='number']").val(newVal);
        spinner.find("input[type='number']").trigger("change");
    });
    btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
            var newVal = oldValue;
        } else {
            var newVal = oldValue - 1;
        }
        spinner.find("input[type='number']").val(newVal);
        spinner.find("input[type='number']").trigger("change");
    });

    // Reviews slider
    $('#shopify-section-1596534761861 .module-inner').slick({
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        centerMode: true,
      	centerPadding: '60px',
      	slidesToShow: 3,
      	responsive: [
        {
            breakpoint: 768,
            settings: {
                centerMode: true,
                centerPadding: '70px',
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                centerMode: true,
                centerPadding: '80px',
                slidesToShow: 1
            }
        }]
    });

  //var benef = document.querySelector('#shopify-section-1595674665219 > section > .module-inner');
  //var legal = document.createElement('p');
  //legal.id = 'beneflegal';
  //legal.innerHTML = "* Statistiques réalisées sur un total de 450 personnes ayant donné un avis sur l’évolution ou la non-évolution de leurs sensations de gênes après 1 mois d'utilisation de FAZUP. (testeurs volontaires utilisant le téléphone mobile au moins 30 minutes par jour).";
  //benef.appendChild(legal);

  //var disclaimer = document.querySelector('#shopify-section-1595676535982 > section > div > div > div > h6');
  //disclaimer.classList.add('beneflegal');
  //var das = document.querySelector('h6.hp-voirtests');
  //das.classList.add('beneflegal');

  /*document.addEventListener('click', function (event) {
    if(!event.target.matches('#voirnotice')) return;
    //var eid = '-' + event.target.id; console.log(eid);
    //var goto = document.getElementById(eid);
    //goto.scrollIntoView();
    const id = '-voirnotice';
    const yOffset = -100;
    const element = document.getElementById(id);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
  }, false);*/

    // FAQs section
    var faq = document.getElementById('faqs');
    if(typeof(faq) != 'undefined' && faq != null) {
        var accItem = document.getElementsByClassName('accordionItem');
        var accHD = document.getElementsByClassName('accordionItemHeading');
        for (i = 0; i < accHD.length; i++) {
            accHD[i].addEventListener('click', toggleItem, false);
        }
        function toggleItem() {
            var itemClass = this.parentNode.className;
            for (i = 0; i < accItem.length; i++) {
                accItem[i].className = 'accordionItem close';
            }
            if (itemClass == 'accordionItem close') {
                this.parentNode.className = 'accordionItem open';
            }
        }
    }

    // Trust section
    var trust = document.getElementById('trust');
    if(typeof(trust) != 'undefined' && trust != null) {
        var getClosest = function (elem, selector) {
        	if(!Element.prototype.matches) {
        	    Element.prototype.matches =
        	        Element.prototype.matchesSelector ||
        	        Element.prototype.mozMatchesSelector ||
        	        Element.prototype.msMatchesSelector ||
        	        Element.prototype.oMatchesSelector ||
        	        Element.prototype.webkitMatchesSelector ||
        	        function(s) {
        	            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        	                i = matches.length;
        	            while (--i >= 0 && matches.item(i) !== this) {}
        	            return i > -1;
        	        };
        	}
        	for ( ; elem && elem !== document; elem = elem.parentNode ) {
        		if ( elem.matches( selector ) ) return elem;
        	}
        	return null;
        };
        document.addEventListener('click', function (event) {
            if(!event.target.matches('.tgl-button')) return;
            var x = getClosest(event.target, '.module-inline-item').nextElementSibling;
            var cl = event.target.getAttribute('data-close');
            var op = event.target.getAttribute('data-open');
            if (x.style.display === "none") {
              x.style.display = "block";
              event.target.innerHTML = cl;
            } else {
              x.style.display = "none";
              event.target.innerHTML = op;
            }
        }, false);
        $('#entreprises').slick({
            infinite: true,
            rows: 1,
            lazyLoad: 'ondemand',
            speed: 300,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            dots: false,
            centerMode: true,
          	centerPadding: '60px',
          	slidesToShow: 1,
            slidesToScroll: 1
        });
        $('#medialogos').slick({
            infinite: true,
            speed: 300,
            lazyLoad: 'ondemand',
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            dots: false,
            centerMode: true,
          	centerPadding: '60px',
          	slidesToShow: 3,
            slidesToScroll: 1
        });
    }

  /*var gif = document.querySelector('#shopify-section-1595858611251 section article img.feature-image');
  var mes = document.createElement('p');
  var mes2 = document.createElement('p');
  mes.id = 'dasgif';
  mes2.id = 'dasgif';
  mes.innerHTML = 'Mesure réalisée sur iPhone 11 Pro Max';
  mes2.innerHTML = '<a href="https://fazup-fr.myshopify.com/pages/fonctionnement">En savoir plus sur les conditions de ce test</a>';
  gif.insertAdjacentElement('beforebegin', mes);
  gif.insertAdjacentElement('beforebegin', mes2);*/

  // Select pack duo
    /*function select(selectId, optionValToSelect){
        var selectElement = document.querySelector(selectId);
        var selectOptions = selectElement.options;
        for (var opt, j = 0; opt = selectOptions[j]; j++) {
            if (opt.value == optionValToSelect) {
                selectElement.selectedIndex = j;
                break;
            }
        }
    }
    select('.single-option-selector', '2 Patchs + 1 Offert');
    $(".home-order-now form select.product-select").val("35415967858854").trigger('change');
    $(".home-order-now form > div.product-options > div.inline-field-wrapper.js-required > div > label > span").empty().append('2 Patchs + 1 Offert');
    $(".product-form-submit-wrap > input").val("Commander : 53,90€");*/

    // Display floating add to cart block only after pricing section
    var aftprc = document.getElementById("tarifs");
    var fltbar = document.getElementById("shopify-section-160407320889a61469");
    fltbar.style.display = 'none';
    document.addEventListener("scroll", checkPos);
    function checkPos() {
        var brchk = sessionStorage.getItem('displayHpBar');
        if(brchk == '1') {
            fltbar.style.display = 'block';
        } else {
            var curr = window.pageYOffset;
            if(curr > aftprc.offsetTop) {
                fltbar.style.display = 'block';
                sessionStorage.setItem('displayHpBar', 1);
            } else {
                fltbar.style.display = 'none';
            }
        }
    }

}

// Ajustement menu déroulant navigation mobile
var aide = document.querySelector('#shopify-section-general-header > .header-drawer > nav > ul > li.has-dropdown.simple-dropdown > a');
aide.style.pointerEvents = 'none';
var drop = document.querySelector('#shopify-section-general-header > .header-drawer > nav > ul > li.has-dropdown.simple-dropdown');
document.addEventListener('click', function (event) {
    if(!event.target.matches('#shopify-section-general-header > .header-drawer > nav > ul > li.has-dropdown.simple-dropdown')) return;
    if(drop.classList.contains('open')) {
        drop.classList.remove('open');
    } else {
        drop.classList.add('open');
    }
}, false);

// Tunnel SAV
/*
if(document.body.classList.contains('template-page-sav')) {

  var saqs = document.querySelectorAll('.accordion-item .accordion-item-title > a');
  document.addEventListener('click', function (event) {
    if(!event.target.matches('svg.icon-plus.accordion-icon, svg.icon-plus.accordion-icon *')) return;
    if(event.target.closest('a').classList.contains('accordion-active')) {
        event.target.closest('a').classList.remove('accordion-active');
        event.target.closest('h1').nextElementSibling.style.display = 'none';
    } else {
        for(i=0;i<saqs.length;i++) {
            if(saqs[i].classList.contains('accordion-active')) {
                saqs[i].classList.remove('accordion-active');
            }
            saqs[i].closest('h1').nextElementSibling.style.display = 'none';
        }
        event.target.closest('a').classList.add('accordion-active');
        event.target.closest('h1').nextElementSibling.style.display = 'block';
    }
    event.target.scrollIntoView({ behavior: 'smooth' , block: 'start', inline: 'nearest'});
  }, false);

}
*/

// Atterrissage influenceurs

function getCookieValueByLoop(a, b, c, d, e) {
  b = document.cookie.split('; ');
  for (e = b.length - 1; e >= 0; e--) {
    c = b[e].split('=');
    if (a === c[0]) return c[1];
  }
  return '';
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function adjustMargins() {
  var hwb = document.getElementById('recommendedby');
  if(typeof(hwb) != 'undefined' && hwb != null) {
  	var height = hwb.offsetHeight;
  	var heightplus = height + 50;
  	var headcont = document.querySelector('main.main-content');
  	headcont.style.paddingTop = height + 'px';
  }
}

function restoreMargins() {
  var headcont = document.querySelector('main.main-content');
  headcont.style.paddingTop = '0px';
}

function closeBar() {
  var close = document.querySelector('#recommendedby');
  close.style.display = 'none';
  var active = document.body;
  active.classList.remove('recommendedby-open');
  restoreMargins();
  var ck = "hwbar_closed";
  var converted = 1;
  var d = new Date();
  d.setTime(d.getTime()+24*60*60*1000);
  var expires = d.toGMTString();
  document.cookie = ck+"="+converted+"; expires="+expires+"; path=/";
}

function getInf(a) {
  var regex = new RegExp(/^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/);
  var validation = regex.test(a);
  if(validation) {
    $.get("https://www.instagram.com/"+a+"/?__a=1")
     .done(function(data) {
	   var img = data["graphql"]["user"]["profile_pic_url_hd"];
       var txt;
       var fullname = data["graphql"]["user"]["full_name"];
       if(fullname != '') {
         txt = fullname;
       } else {
         txt = a;
       }
       var rcm = document.createElement('div');
       rcm.id = 'recommendedby';
       rcm.innerHTML = '<i class="fa fa-times-circle"></i><img src="' + img + '" alt="' + txt + '" /><p><span>' + txt + '</span> vous recommande <img src="https://cdn.shopify.com/s/files/1/0431/9500/7142/files/logo-fazup_898079f0-2f40-4477-8c0b-15b3f3a1fd10_300x71.png?v=1595931889" alt="Fazup" /></p>';
       hdr.insertAdjacentElement('afterend', rcm);
	   adjustMargins();
     })
     .fail(function() {
       console.log('Username was not found!')
     })
  } else {
    console.log('The username is invalid!')
  }
}

var hwbar = getCookieValueByLoop('hwbar_closed');
var inf = getUrlParameter('utm_term');
var src = getUrlParameter('utm_source');
var med = getUrlParameter('utm_medium');
var hdr = document.querySelector('header.main-header');

var fai = document.createElement('link');
fai.rel = 'stylesheet';
fai.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';
document.getElementsByTagName('head')[0].appendChild(fai);

if(hwbar != 1) {
  if(src == 'instagram' && med == 'influenceur' && inf != '') {
    getInf(inf);
  }
}

window.addEventListener("resize", function(){
  if(hwbar != 1 && src == 'instagram' && med == 'influenceur' && inf != '') {
    adjustMargins();
  }
});

document.addEventListener('click', function (event) {
  if(!event.target.matches('#recommendedby .fa-times-circle')) return;
  closeBar();
}, false);

// Tunnel SAV

var simulateClick = function (elem) {
  var evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  var canceled = !elem.dispatchEvent(evt);
};

if(document.body.classList.contains('template-page-sav')) {
    console.log("started");

    document.addEventListener('click', function (event) {
        if(!event.target.matches('.accordion-open-form')) return;
        if(event.target.classList.contains('open')) {
            event.target.nextElementSibling.style.display = 'none';
            event.target.classList.remove('open');
        } else {
            event.target.nextElementSibling.style.display = 'block';
            event.target.classList.add('open');
        }
    }, false);


    var art = document.querySelector('#shopify-section-module-sav > article:first-of-type h1 .accordion-inline-title');
    //simulateClick(art);
    console.log("finished");

    document.addEventListener('click', function (event) {
        if(!event.target.matches('h1.accordion-item-title, h1.accordion-item-title *')) return;
        setTimeout(function(){
            console.log("accordion click");
            var top = event.target.closest('article');
            top.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'start'
            });
            console.log("scrolled");
        }, 750);
    }, false);

    // Display confirmation message + refresh after form submission

    function buildPop() {

        console.log("build pop-up");

        // Popup configuration
        var type = 'standard'; // values : standard / exit
        var position = 'central'; // values : topright, topleft, bottomleft, bottomright, central
        var fond = 'yes'; // overlay, values : yes / no
        var id = 'FAZMERCI'; // campaign ID, must be unique to set cookie

        //////////////////////////////////////////////////////////////////////////////////////////

        var pp = document.createElement('div');
        pp.id = 'camp_popup';
        pp.classList.add('gtm-popup','overlay');
        pp.style.display = 'none';
        pp.innerHTML = '<div class="popup"><h2 id="camp_title">Votre message a bien été envoyé.</h2><span id="camp_popup_close" class="close">×</span><div id="camp_content" class="content"><p>Vous recevrez rapidement une réponse.</p></div></div>';
        document.body.appendChild(pp);

        var pop = document.querySelector('#camp_popup > .popup');
        pop.classList.add(position);

        if (fond == 'yes') {
            var wrap = document.querySelector('#camp_popup');
            wrap.classList.add('on');
        }

        if (type == "standard") {
            console.log("is standard");
            document.getElementById("camp_popup").style.display = 'block';
        }
    }

    var posted = getUrlParameter('contact_posted');
    console.log(posted);
    if(posted == 'true') {
        console.log('form submitted');
        buildPop();
        var faqfullurl = window.location.href;
        var faqurl = faqfullurl.split('?');
        console.log(faqurl[0]);
        setTimeout(function(){
            window.location.href = faqurl[0];
        }, 5000);
    }

    document.addEventListener('click', function (event) {
        console.log("Click close occured");
        if(!event.target.matches('#camp_popup_close')) return;
        console.log("click matched");
        document.getElementById("camp_popup").style.display = 'none';
    }, false);

}

// Rubrique aide ouverte par défaut
class ClassWatcher {
      constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
         this.targetNode = targetNode
         this.classToWatch = classToWatch
         this.classAddedCallback = classAddedCallback
         this.classRemovedCallback = classRemovedCallback
         this.observer = null
         this.lastClassState = targetNode.classList.contains(this.classToWatch)
         this.init()
      }
      init() {
         this.observer = new MutationObserver(this.mutationCallback)
         this.observe()
      }
      observe() {
         this.observer.observe(this.targetNode, { attributes: true })
      }
      disconnect() {
         this.observer.disconnect()
      }
      mutationCallback = mutationsList => {
         for(let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
               let currentClassState = mutation.target.classList.contains(this.classToWatch)
               if(this.lastClassState !== currentClassState) {
                  this.lastClassState = currentClassState
                  if(currentClassState) {
                     this.classAddedCallback()
                  }
                  else {
                     this.classRemovedCallback()
                  }
               }
            }
         }
      }
   }
   let targetNode = document.querySelector('body')
   function workOnClassAdd() {
      console.log("menu opened!");
      var aid = document.querySelector('nav.navigation.mobile ul li:last-child');
      if(typeof(aid) != 'undefined' && aid != null) {
        simulateClick(aid);
      }
   }
   function workOnClassRemoval() {
      console.log("menu closed");
   }
   let classWatcher = new ClassWatcher(targetNode, 'showing-drawer', workOnClassAdd, workOnClassRemoval)


if(document.body.classList.contains('template-product-slideshow')) {

    // Make star rating bigger on product page
    var str = setInterval(biggerStars, 500);
    function biggerStars() {
        starHelper();
    }
    function starHelper() {
        var stars = document.querySelectorAll('.product-details-inline .r-icon--star1');
        if(stars.length > 0){
            for(s=0;s<stars.length;s++) {
                stars[s].setAttribute('style','font-size: 20px !important; max-width: 20px !important;');
            }
            var srt = document.querySelector('.r--star-gray-active');
            srt.setAttribute('style', 'height: 20px !important; width: calc(94.4%);');
            var stri = document.querySelector('.r--stars-item');
            stri.setAttribute('style', 'width: 110px !important;');
            var strj = document.querySelector('.r--stars-item .r--star-grade.my');
            strj.setAttribute('style', 'width: 110px !important; color: #fdbc00;');
            //clearInterval(str);
        }
    }

    // Create sticky add to cart on product page
    window.onscroll = function() {
        var frm = document.querySelector('.product-form');
        var trig = document.getElementById('stickcart');
        if (trig.offsetTop < window.pageYOffset) {
            frm.classList.add("stickyform");
            //const yos = -10;
            //const stc = document.getElementById('stickcart');
            //const z = stc.getBoundingClientRect().top + window.pageYOffset + yos;
            //window.scrollTo({top: z, behavior: 'auto'});
        } else {
            frm.classList.remove("stickyform");
        }
    }


    // Identify active variant
    var slc = document.querySelector('.template-product-slideshow :checked+.input-checkbox-title, :checked+.input-checkbox-title:hover')
    if(typeof(slc) != 'undefined' && slc != null) {
    	slc.parentNode.classList.add('activevariant');
    }
    document.addEventListener('click', function (event) {
        if(!event.target.matches('.input-checkbox-title')) return;
        var actv = document.querySelector('label.input-checkbox-wrapper.activevariant');
        actv.classList.remove('activevariant');
        event.target.parentNode.classList.add('activevariant');
    }, false);

    // Open/close alternate variants
    document.addEventListener('click', function (event) {
        if(!event.target.matches('.change-variant i')) return;
        if(event.target.matches('i.fa-angle-down')) {
            var fmr = document.querySelector('.product-form');
            fmr.classList.add('openvariants');
            var chg = document.querySelector('.change-variant i');
            chg.classList.remove('fa-angle-down');
            chg.classList.add('fa-angle-up');
        } else {
            var fms = document.querySelector('.product-form');
            fms.classList.remove('openvariants');
            var cgh = document.querySelector('.change-variant i');
            cgh.classList.remove('fa-angle-up');
            cgh.classList.add('fa-angle-down');
        }
    }, false);

    // Close alternate variants after picking variant
    document.addEventListener('click', function (event) {
        if(!event.target.matches('.product-form.stickyform.openvariants .input-checkbox-title')) return;
        var gms = document.querySelector('.product-form');
        gms.classList.remove('openvariants');
        var dgh = document.querySelector('.change-variant i');
        dgh.classList.remove('fa-angle-up');
        dgh.classList.add('fa-angle-down');
    }, false);

    // Add price to button
    function updateBtn() {
        var atcb = document.querySelector('.add-to-cart input.button');
        var prce = document.querySelector('.product-price .price .money').textContent;
        atcb.value = "Add to cart : " + prce;
    }
    setTimeout(updateBtn, 1000);
    document.addEventListener('click', function (event) {
        if(!event.target.matches('.product-form .input-checkbox-title')) return;
        setTimeout(updateBtn, 1000);
    }, false);

    // Accordion content
    var acc = document.getElementsByClassName("accordion");
  	if(acc.length > 0) {
      var i;
      for (i = 0; i < acc.length; i++) {
          acc[i].addEventListener("click", function() {
              this.classList.toggle("active");
              var panel = this.nextElementSibling;
              if (panel.style.maxHeight) {
                  panel.style.maxHeight = null;
              } else {
                  panel.style.maxHeight = panel.scrollHeight + "px";
              }
          });
      }
      acc[0].classList.toggle("active");
      var pan = acc[0].nextElementSibling;
      pan.style.maxHeight = pan.scrollHeight + "px";
    }

    // Scroll to reviews
    document.addEventListener('click', function (event) {
        if(!event.target.matches('.r-icon--star1')) return;
        const yOffset = -475;
        const st = document.querySelector('.lt-block-reviews');
        const y = st.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }, false);

    // FAQs section
    var faq = document.getElementById('faqs');
    if(typeof(faq) != 'undefined' && faq != null) {
        var accItem = document.getElementsByClassName('accordionItem');
        var accHD = document.getElementsByClassName('accordionItemHeading');
        for (i = 0; i < accHD.length; i++) {
            accHD[i].addEventListener('click', toggleItem, false);
        }
        function toggleItem() {
            var itemClass = this.parentNode.className;
            for (i = 0; i < accItem.length; i++) {
                accItem[i].className = 'accordionItem close';
            }
            if (itemClass == 'accordionItem close') {
                this.parentNode.className = 'accordionItem open';
            }
        }
    }

    // Add reviews count (static)
    /*var ctrev = setInterval(addReviews, 500);
    function addReviews() {
        addCount();
    }
    function addCount() {
        console.log('addCount started');
        var rw = document.querySelector('.review-widget .r--stars.cpl');
        if(typeof(rw) != 'undefined' && rw != null) {
            var rvc = document.createElement('div');
            rvc.id = 'rvcount';
            rvc.innerHTML = " 1203 avis";
            rw.insertAdjacentElement('afterend', rvc);
            clearInterval(ctrev);
        }
    }*/

    // Put trust builders at the right place
    var vpw;
    var tstb = document.getElementById('shopify-section-home-text-columns-with-images');
    var pdpb = document.getElementById('shopify-section-module-product');
    var setvpw = function () {
    	vpw = window.innerWidth || document.documentElement.clientWidth;
    }
    var moveTrust = function () {
    	if (vpw > 719) {
    	    var tstbm = document.querySelector('.main-content > #shopify-section-home-text-columns-with-images');
            if(typeof(tstbm) != 'undefined' && tstbm != null) {
                pdpb.appendChild(tstb);
            }
    	} else {
    		var tstbd = document.querySelector('#shopify-section-module-product > #shopify-section-home-text-columns-with-images');
            if(typeof(tstbd) != 'undefined' && tstbd != null) {
                pdpb.insertAdjacentElement('afterend', tstb);
            }
    	}
    }
    setvpw();
    moveTrust();
    window.addEventListener('resize', function () {
    	setvpw();
    	moveTrust();
    }, false);



}

if(document.body.classList.contains('template-product-colors')) {

    // Variables
    //var itms = {0:"0",1:"3",2:"4",3:"6"};
    var itms = {0:"0",1:"3",2:"6"};

    // Display accurate number of patches
    function displayColors() {
        var pck = document.querySelector('.input-checkbox-wrapper.activevariant');
        var pci = pck.getAttribute('for');
        var pcj = pci.split('-')
        var nbr = pcj[pcj.length-1]; //console.log(nbr);
        console.log(itms[parseInt(nbr)]);
        var clrs = document.querySelectorAll('#color-selector .patch-color');
        for(c=0;c<itms[parseInt(nbr)];c++) {
            if(!clrs[c].classList.contains('open')) {
                clrs[c].classList.add('open');
            }
        }
        for(c=itms[parseInt(nbr)];c<clrs.length;c++) {
            if(clrs[c].classList.contains('open')) {
                clrs[c].classList.remove('open');
            }
        }
        if(itms[parseInt(nbr)] == 0 ) {
            document.querySelector('#color-selector h3').style.display = 'none';
        } else {
            document.querySelector('#color-selector h3').style.display = 'block';
        }
      	var sec = document.getElementById('patch-2');
      	var ipts = sec.querySelectorAll('label:not(.argent) input');
        if(nbr == 2) {
          if(!sec.classList.contains('silver')) {
          	sec.classList.add('silver');
          }
          for(i=0;i<ipts.length;i++) {
            ipts[i].disabled = true;
          }
          sec.querySelector('label.argent input').checked = true;
        } else {
		  if(sec.classList.contains('silver')) {
          	sec.classList.remove('silver');
          }
          for(i=0;i<ipts.length;i++) {
            if(ipts[i].value == 'noir') {
              ipts[i].disabled = false;
            } else {
              ipts[i].disabled = false;
            }
          }
        }
    }
    displayColors();
    document.addEventListener('click', function (event) {
        console.log('clicked');
        if(!event.target.matches('.input-checkbox-title')) return;
        console.log('matched');
        displayColors();
    }, false);



    // Add to cart logic
    function addToCartSuccess() {
        console.log("added to cart");
      	var ckt = getCookieValueByLoop('ab_atc');
      	if(ckt == 'checkout') {
        	window.location.href = "/checkout";
        } else {
         	window.location.href = "/cart"; 
        }
        
    }
    $("#atcbtn").click(function() {

        // Build line items
        var varids = {"argent":"40953292423334","blanc":"40953254346918","rose":"40953298190502","noir":"40953314640038"};
        var p2 = document.querySelector('input[type="radio"][name="patch-2-color"]:checked'); console.log('p2: ' + p2.value);
        var p3 = document.querySelector('input[type="radio"][name="patch-3-color"]:checked'); console.log('p3: ' + p3.value);
        var p4 = document.querySelector('input[type="radio"][name="patch-4-color"]:checked'); console.log('p4: ' + p4.value);
        var p5 = document.querySelector('input[type="radio"][name="patch-5-color"]:checked'); console.log('p5: ' + p5.value);
      	var p6 = document.querySelector('input[type="radio"][name="patch-6-color"]:checked'); console.log('p6: ' + p6.value);
        //console.log(varids[p2.value]);

        var opns = document.querySelectorAll('.patch-color.open');
        console.log('length: ' + opns.length);
        var data;
        if(opns.length == 0) {
            var data = {
                items: [
                    {
                        quantity: 1,
                        id: "40907864211622"
                    }
                ]
            };
        } else if(opns.length == 2) {
            var data = {
                items: [
                    {
                        quantity: 1,
                        id: 40907864244390
                    },
                    {
                        quantity: 1,
                        id: varids[p2.value]
                    }
                ]
            };
            console.log(data);
        } else if(opns.length == 3) {

            const dta = {};
            const dtc = [varids[p2.value], varids[p3.value]];
            dtc.forEach(function (x) { dta[x] = (dta[x] || 0) + 1; });
            console.log(dta);
            var count = 0;
            for(var key in dta) {
                if(dta.hasOwnProperty(key)) {
                    count++;
                }
            }
            console.log(count);
            if(count == 1) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864244390
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        }
                    ]
                };
            } else if(count == 2) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864244390
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        }
                    ]
                };
            }
        } else if(opns.length == 4) {

            const dta = {};
            const dtc = [varids[p2.value], varids[p3.value], varids[p4.value]];
            dtc.forEach(function (x) { dta[x] = (dta[x] || 0) + 1; });
            console.log(dta);
            var count = 0;
            for(var key in dta) {
                if(dta.hasOwnProperty(key)) {
                    count++;
                }
            }
            console.log(count);
            if(count == 1) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864277158
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        }
                    ]
                };
            } else if(count == 2) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864277158
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        }
                    ]
                };
            } else if(count == 3) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864277158
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[2]),
                            id: Object.keys(dta)[2]
                        }
                    ]
                };
            } else if(count == 4) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864277158
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[2]),
                            id: Object.keys(dta)[2]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[3]),
                            id: Object.keys(dta)[3]
                        }
                    ]
                };
            }
            console.log(data);
        } else if(opns.length == 6) {
            const dta = {};
            const dtc = [varids[p3.value], varids[p4.value], varids[p5.value], varids[p6.value]];
            dtc.forEach(function (x) { dta[x] = (dta[x] || 0) + 1; });
            console.log(dta);
            var count = 0;
            for(var key in dta) {
                if(dta.hasOwnProperty(key)) {
                    count++;
                }
            }
            console.log(count);
            if(count == 1) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864309926
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        }
                    ]
                };
            } else if(count == 2) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864309926
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        }
                    ]
                };
            } else if(count == 3) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864309926
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[2]),
                            id: Object.keys(dta)[2]
                        }
                    ]
                };
            } else if(count == 4) {
                var data = {
                    items: [
                        {
                            quantity: 1,
                            id: 40907864309926
                        },
                        {
                            quantity: parseInt(Object.values(dta)[0]),
                            id: Object.keys(dta)[0]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[1]),
                            id: Object.keys(dta)[1]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[2]),
                            id: Object.keys(dta)[2]
                        },
                        {
                            quantity: parseInt(Object.values(dta)[3]),
                            id: Object.keys(dta)[3]
                        }
                    ]
                };
            }
            console.log(data);
        }
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: addToCartSuccess
        });
    });
  
  // add CTA in sticky block
  var stf = document.querySelector('.product-form');
  var stc = document.createElement('button');
  stc.classList.add('customizebtn');
  stc.innerHTML = 'Personnaliser vos patchs';
  stf.appendChild(stc);
  document.addEventListener('click', function (event) {
    if(!event.target.matches('.customizebtn')) return;
    var goto = document.getElementById('color-selector');
    //goto.scrollIntoView({ behavior: 'smooth' , block: 'start', inline: 'nearest'});
    const yOffset = -200;
    const y = goto.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({top: y, behavior: 'smooth'});
  }, false);
  
  

}
/*if(document.body.classList.contains('template-index')) {

  setInterval(function(){ 
    var pfsw = document.querySelector('.product-form-submit-wrap');
    var dest;
    var slct = document.querySelector('.shopify-product-form select.single-option-selector').value;
    console.log(slct);
    if(slct.indexOf('Family') !== -1) {
      var dest = 'https://fazup.fr/products/fazup-patchs-couleur?variant=40907864309926#color-selector';
    } else if(slct.indexOf('Trio') !== -1) {
      var dest = 'https://fazup.fr/products/fazup-patchs-couleur?variant=40907864277158#color-selector';
    } else if(slct.indexOf('Duo') !== -1) {
      var dest = 'https://fazup.fr/products/fazup-patchs-couleur?variant=40907864244390#color-selector';
    } else {
      var dest = 'https://fazup.fr/products/fazup-patchs-couleur';
    }
    pfsw.innerHTML = '<a href="' + dest + '" class="customizepdt">Personnaliser</a>';
  }, 1000);

}*/

// TEMPORARY Change product page URL
/*var lkm = document.querySelector('.navigation.mobile ul > li:nth-child(2) > a');
if(typeof(lkm) != 'undefined' && lkm != null) {
    lkm.href = '/products/patchs';
}
var lkd = document.querySelector('.navigation.header ul > li:nth-child(2) > a');
if(typeof(lkd) != 'undefined' && lkd != null) {
    lkd.href = '/products/patchs';
}*/
/*var lks = document.querySelectorAll('a[href="/products/patch-fazup"]');
for(l=0;l<lks.length;l++) {
    lks[l].href = '/products/patchs';
}*/
/*var lru = window.location.href;
if(lru.indexOf('/products/patchs') >= 0) {
    window.location.href = '/products/fazup-patchs-couleur';
}*/
/*if(lru.indexOf('ab=product') >= 0) {
    window.location.href = '/products/patch-fazup';
}*/
/*if(lru.indexOf('/products/patch-fazup') >= 0) {
    window.location.href = '/products/fazup-patchs-couleur';
}*/

  // Helper function
  function waitForElement(selector, trigger, delayInterval, delayTimeout) {
    var interval = setInterval(function () {
      if (
        document &&
        document.querySelector(selector) &&
        document.querySelectorAll(selector).length > 0
      ) {
        clearInterval(interval);
        trigger();
      }
    }, delayInterval);
    setTimeout(function () {
      clearInterval(interval);
    }, delayTimeout);
  }
  

  function initTranscy() {
    //console.log('initTranscy started');
    // Hide Transcy widget
    document.getElementById('transcyBtnSwitcher').style.display = 'none';
    // Update links
    var anchors = document.getElementsByTagName("a");
    for (var i = 0; i < anchors.length; i++) {
      var b = anchors[i].href;
      //console.log(b);
      if(b.indexOf("fazup.eu") !== -1 && b.indexOf("/en-us") == -1 ) {
        //console.log("yes");
        var c = b.replace('fazup.eu', 'fazup.eu/en-us');
        //console.log(c);
        anchors[i].href = c;
      }
    }
  }


var pnt = window.location.pathname;
if(pnt.indexOf('/en-us') !== -1) {
  //console.log("transcy test");
  waitForElement("#transcyBtnSwitcher", initTranscy, 100, 10000);
}



